import React from 'react'
import DashboardLayout from './layout'
import MyInput from '../components/MyInput'
import MyTextArea from '../components/MyTextArea'
import MyButton from '../components/buttons'
import { FaUser, FaEnvelope } from 'react-icons/fa'
import { FormControl } from '@mui/material'
import { useTranslation } from 'react-i18next'
import ContactForm from '../components/ContactForm'
import ContactFormAuthenticated from '../components/ContactFormAuthenticated'

function Support() {
  const { t } = useTranslation()

  return (
    <div>
      <DashboardLayout title='Contact'>
        <ContactFormAuthenticated />
      </DashboardLayout>
    </div>
  )
}

export default Support
